import { render, staticRenderFns } from "./outgoing-call-modal.vue?vue&type=template&id=c67a20b0&"
import script from "./outgoing-call-modal.vue?vue&type=script&lang=js&"
export * from "./outgoing-call-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports